

function TermsCondition() {
    return (
      <div className="App">
        <p>
        <h3>Terms and Conditions for Ramba Medical Software</h3>

PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY BEFORE USING RAMBA MEDICAL SOFTWARE. BY USING RAMBA MEDICAL SOFTWARE, YOU AGREE TO THESE TERMS AND CONDITIONS. IF YOU DO NOT AGREE TO THESE TERMS AND CONDITIONS, DO NOT USE RAMBA MEDICAL SOFTWARE.

<h4>INTRODUCTION</h4>

Ramba Medical Software is a software platform that allows doctors and patients to connect for virtual consultations, medical advice, and other related services. These Terms and Conditions apply to all users of Ramba Medical Software, including doctors, patients, and other healthcare providers.

<h4>USE OF RAMBA MEDICAL SOFTWARE</h4>

2.1 License. Ramba Medical Software is licensed, not sold, to you for use only under the terms of this license. The license is granted for the term of use of the software.
<br />
2.2 Eligibility. You must be at least 18 years old and have the legal capacity to enter into agreements to use Ramba Medical Software. By using Ramba Medical Software, you represent and warrant that you meet these eligibility requirements.
<br />
2.3 Registration. To use Ramba Medical Software, you must register and create an account. You agree to provide accurate and complete information during the registration process, and to keep your account information up-to-date.
<br />
2.4 User Conduct. You agree to use Ramba Medical Software only for lawful purposes and in accordance with these Terms and Conditions. You agree not to use Ramba Medical Software in any way that violates any applicable federal, state, local, or international law or regulation.
<br />
2.5 Prohibited Conduct. You agree not to engage in any conduct that could damage, disable, overburden, or impair Ramba Medical Software, or interfere with any other party’s use of Ramba Medical Software. You agree not to attempt to gain unauthorized access to any portion of Ramba Medical Software, or any other systems or networks connected to Ramba Medical Software.
<br />
2.6 User Content. You are solely responsible for any content that you upload, publish, display, or otherwise transmit through Ramba Medical Software. You agree that you will not upload, publish, display, or transmit any content that is unlawful, harmful, threatening, abusive, harassing, defamatory, vulgar, obscene, or invasive of another’s privacy.
<br />
2.7 User Feedback. You may submit comments, suggestions, or other feedback about Ramba Medical Software. By submitting feedback, you agree that we may use and incorporate your feedback without any obligation to compensate you.
<br />
<h4>PRIVACY POLICY</h4>

Our Privacy Policy governs the collection, use, and disclosure of personal information and other data collected through Ramba Medical Software. You acknowledge that you have read our Privacy Policy and agree to its terms.
<br />
<h4>INTELLECTUAL PROPERTY RIGHTS</h4>

Ramba Medical Software and its entire contents, features, and functionality (including but not limited to all information, software, text, displays, images, video, and audio) are owned by us, our licensors, or other providers of such material and are protected by international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws.
<br />
<h4>DISCLAIMERS</h4>

5.1 No Medical Advice. Ramba Medical Software is intended for informational purposes only and does not provide medical advice. You should not rely on Ramba Medical Software as a substitute for professional medical advice, diagnosis, or treatment. Always seek the advice of your physician or other qualified healthcare provider with any questions you may have regarding a medical condition.
<br />
5.2 No Endorsement. We do not endorse any specific tests, physicians, products, procedures, opinions, or other information that may be mentioned on Ramba Medical Software.
<br />
5.3 No Warranties. Ramba Medical Software is provided “
        </p>

      </div>
    );
  }
  
  export default TermsCondition;
  
